import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import Vant from 'vant'
import { Lazyload, ImagePreview } from 'vant'
import 'vant/lib/index.css'

Vue.use(Vant)
Vue.use(Lazyload)
Vue.use(ImagePreview)

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount('#app')
